import store from '../../store/store';
import { ActionStatus } from '../../common/constants/action-status';
import { StoreState } from '../../store/store.interface';
import { isHeStudent } from '../user-profile/user-profile.selectors';

export const HE_STUDENT_CONFIRMED_EVENT = 'mhecomm-he-student-confirmed';
const STUDENT_CONFIRMATION_RETRY_DELAYS = [0, 100, 300, 750];

export function initializeHeStudentPdpBridge(reduxStore = store): void {
  let notificationScheduled = false;
  let unsubscribe: (() => void) | undefined;

  const notifyConfirmedStudent = (): void => {
    if (notificationScheduled) {
      return;
    }

    const state = reduxStore.getState() as StoreState;
    const profileResponse = state.userProfileState.userProfileResponse;
    if (profileResponse.status !== ActionStatus.succeeded || !isHeStudent(state)) {
      return;
    }

    notificationScheduled = true;
    unsubscribe?.();
    STUDENT_CONFIRMATION_RETRY_DELAYS.forEach(delay => {
      window.setTimeout(() => document.dispatchEvent(new CustomEvent(HE_STUDENT_CONFIRMED_EVENT)), delay);
    });
  };

  notifyConfirmedStudent();
  if (!notificationScheduled) {
    unsubscribe = reduxStore.subscribe(notifyConfirmedStudent);
  }
}

initializeHeStudentPdpBridge();
